export enum TimePeriod {
  daily = 'daily',
  weekly = 'weekly',
  monthly = 'monthly',
  perRequest = 'perRequest',
  custom = 'custom',
}
